export default "__VITE_ASSET__4QDWx_IZ__"